import { Controller } from "stimulus"

export default class extends Controller {
  static targets = ["modal"]

  connect() {
    this._onKeydown = (event) => {
      if (!this.hasModalTarget) return
      if (event.key === "Escape" && this.modalTarget.style.display !== "none") this.hide()
    }
    document.addEventListener("keydown", this._onKeydown)
  }

  disconnect() {
    document.removeEventListener("keydown", this._onKeydown)
    document.body.style.overflow = ""
  }

  show(event) {
    event?.preventDefault()
    this.modalTarget.style.display = "flex"
    document.body.style.overflow = "hidden"
  }

  hide(event) {
    event?.preventDefault()
    this.modalTarget.style.display = "none"
    document.body.style.overflow = ""
  }

  stopPropagation(event) {
    event.stopPropagation()
  }

  linkAccounts(event) {
    event?.preventDefault()
    this.hide(event)
    document.querySelector(".link-button")?.click()
  }
}
